// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.more-endless_inline_6e5487da .more-endless__item_6e5487da {
  display: inline-flex;
  white-space: normal;
  line-height: 1.715;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"more-endless_inline": `more-endless_inline_6e5487da`,
	"more-endless__item": `more-endless__item_6e5487da`
};
export default ___CSS_LOADER_EXPORT___;
